export default ({store, route, redirect}) => {

    if (!store.state.auth.loggedIn)
        return redirect('/login');

    const authorizationLevels = route.meta.map((meta) => {
        let userRoles = store.state.auth.user.roles;
        let routeRoles = meta.auth.roles;
        //console.log('store role ',userRoles)
        //console.log('page role ',routeRoles)
        for (let role of userRoles)
            if (routeRoles.includes(role))
                return true;
        return redirect('/login')
    })
}
